import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Box, makeStyles } from '@material-ui/core';
import { Link } from '@reach/router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FontSizes, ResolutionColors } from '../../../../core/config/mainTheme';
import { BenchmarkCompanyView } from '../../../../generated/model/benchmarkCompanyView';
import ResolutionIcon from '../../../../pages/Benchmark/BenchmarkPage/BenchmarkTabs/CompanyResolve/CompanyBlock/ResolutionIcon';

interface Props extends ICellRendererParams {
  data: BenchmarkCompanyView;
}

const BenchmarkCompanyLinkCellRenderer: React.FC<Props> = ({ value, data }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const label = value && value !== '' ? value : t('companies:unknown');

  const color = () => {
    switch (data?.benchmarkInfo?.status) {
      case 'ACCEPTED':
        return ResolutionColors.Accepted;
      case 'POSTPONED':
        return ResolutionColors.Pending;
      case 'REJECTED':
        return ResolutionColors.Rejected;
    }
  };

  const icon = () => {
    switch (data?.benchmarkInfo?.status) {
      case 'ACCEPTED':
        return <ResolutionIcon icon={'checkMark'} />;
      case 'POSTPONED':
        return <ResolutionIcon icon={'clockMark'} />;
      case 'REJECTED':
        return <ResolutionIcon icon={'xMark'} />;
    }
  };

  return (
    <Box className={classes.subheader}>
      {data?.benchmarkInfo?.status && (
        <span className={classes.dot} style={{ backgroundColor: color() }}>
          {icon()}
        </span>
      )}
      <Link className={classes.link} to={''}>
        {label}
      </Link>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  subheader: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  link: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: FontSizes.fontWeight.bold,
  },
  dot: {
    height: '14px',
    width: '14px',
    minHeight: '14px',
    minWidth: '14px',
    borderRadius: '50%',
    marginRight: '6px',
    display: 'inline-flex',
    alignItems: 'center',

    '& img': {
      maxHeight: '8px',
      maxWidth: '8px',
      margin: 'auto',
    },
  },
}));

export default BenchmarkCompanyLinkCellRenderer;
